import { AnimatedSection, SectionHeader, GlowCard } from '@/components/ui';
import { PhoneMissed, Repeat2, MonitorSmartphone } from 'lucide-react';

// Single-vertical positioning section: local service businesses (plumbers, HVAC,
// salons, clinics, contractors). One narrow audience that self-identifies beats
// a generic "for all businesses" pitch.
const PAIN_POINTS = [
  {
    Icon: PhoneMissed,
    title: 'After-hours questions become booked jobs',
    desc: "Most customers reach out evenings and weekends — exactly when you can't answer. ChytBot quotes your services, shares your availability, and captures the lead instead of losing it to the next Google result.",
  },
  {
    Icon: Repeat2,
    title: 'Stop repeating the same 10 answers',
    desc: 'Hours, service area, pricing, licensing, "do you handle X?" — upload your rate sheet and FAQ once, and the bot handles the repetitive questions so you can stay on the job.',
  },
  {
    Icon: MonitorSmartphone,
    title: 'Works on the website you already have',
    desc: 'WordPress, Wix, Squarespace, or a site someone built for you years ago — paste one line of code and it works. Nothing new to learn or maintain.',
  },
];

export const BuiltForLocalServices = () => (
  <section id="local-services" className="py-16 md:py-24">
    <div className="container">
      <AnimatedSection>
        <SectionHeader
          align="center"
          title="Built for local service businesses"
          description="Plumbers, HVAC, salons, clinics, contractors — if customers call or text you with questions, ChytBot was built for your day."
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {PAIN_POINTS.map(({ Icon, title, desc }) => (
            <GlowCard key={title} className="h-full p-6">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl border border-primary/20 bg-background shadow-sm shadow-primary/10">
                <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
              </div>
              <h3 className="font-display text-lg font-bold text-foreground">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
            </GlowCard>
          ))}
        </div>
      </AnimatedSection>
    </div>
  </section>
);
